import React from "react";
import { ContactAvatar } from "../../permits/components/ContactAvatar";

interface IContactName {
  firstName?: string;
  lastName?: string;
}

/**
 * Render's a contact's name with an avatar
 *
 * @param firstName - The first name of the person
 * @param lastName - The last name of the person
 */
export default function ContactNameWithAvatar({ firstName = "", lastName = "" }: IContactName) {
  return (
    <div className='tw-flex tw-items-center tw-gap-3'>
      <ContactAvatar firstName={firstName} lastName={lastName} />
      <div>
        {firstName} {lastName}
      </div>
    </div>
  );
}
